import { Link } from "@react-pdf/renderer";
import { useEffect, useState } from "react";
import { PropTypes } from 'prop-types';
import { webalize } from 'webalize';
import useLocales from '../../../hooks/useLocales';
import { dispatch } from "../../../redux/store";
import { getArticlePreview } from '../../../redux/slices/articles';
import ArticlePrintStyle from "./ArticlePrintStyle";

ArticlePrintLinks.propTypes = {
    links: PropTypes.array
};

export default function ArticlePrintLinks({ links }) {

    const { currentLang } = useLocales();
    // const { linked } = useSelector((state) => state.articles);
    const [ linkNames, setLinkNames ] = useState([]);
    const styles = ArticlePrintStyle;

    useEffect(() => {
        if (links && links.length) {
            links.forEach((item) => {
                dispatch(getArticlePreview(item.articleKey, { locale: currentLang.getValue }))
                .then((resp) => {
                    setLinkNames((old) => [...old, { title: resp?.title, key: resp?.key }]);
                });
            });
        }
    }, [ links, currentLang ]);

    return linkNames.map((link, idx) => <Link src={`https://${process.env.REACT_APP_HOST}/clanky/${link.key}/${webalize(link.title)}`} key={link.key + link.title + idx} style={{ ...styles.listItem }}>{link.title}</Link>);
}